<script setup lang="ts">
import { Briefcase, BriefcaseBusiness, Contact, Home, Info, Menu, Wrench, X } from "lucide-vue-next";
import { ref } from "vue";

import "@/assets/styles/sidebar.css";

const isOpen = ref(false);
const closeSidebar = () => (isOpen.value = false);
</script>

<template>
  <header class="topbar" aria-label="Hauptnavigation">
    <RouterLink to="/" class="brand" aria-label="Dachdecker Beispiel – Startseite">
      <img src="@/assets/images/logo.png" alt="" class="brand-logo" />
      <div class="brand-text">
        <strong>Dachdecker Beispiel</strong>
        <span>Meisterbetrieb für Mannheim & Region</span>
      </div>
    </RouterLink>

    <nav class="desktop-nav" aria-label="Seitennavigation">
      <RouterLink to="/">Start</RouterLink>
      <RouterLink to="/ueber">Über uns</RouterLink>
      <RouterLink to="/leistungen">Leistungen</RouterLink>
      <RouterLink to="/referenzen">Referenzen</RouterLink>
      <RouterLink to="/karriere">Karriere</RouterLink>
      <RouterLink to="/kontakt" class="nav-cta">Angebot anfragen</RouterLink>
    </nav>

    <button class="menu-btn" type="button" aria-label="Seitenmenü öffnen" :aria-expanded="isOpen" @click="isOpen = true">
      <Menu />
    </button>
  </header>

  <Transition name="fade">
    <div v-if="isOpen" class="sidebar-overlay" @click="closeSidebar" />
  </Transition>

  <aside class="sidebar" :class="{ open: isOpen }" :aria-hidden="!isOpen">
    <div class="sidebar-header">
      <div>
        <span class="drawer-kicker">Schnellzugriff</span>
        <h2>Wohin dürfen wir Sie führen?</h2>
      </div>
      <button class="close-btn" type="button" aria-label="Seitenmenü schließen" @click="closeSidebar"><X /></button>
    </div>

    <nav class="sidebar-links" aria-label="Seitenmenü">
      <RouterLink to="/" class="points-link" @click="closeSidebar"><Home />Startseite</RouterLink>
      <RouterLink to="/ueber" class="points-link" @click="closeSidebar"><Info />Über uns</RouterLink>
      <RouterLink to="/leistungen" class="points-link" @click="closeSidebar"><Wrench />Leistungen</RouterLink>
      <RouterLink to="/referenzen" class="points-link" @click="closeSidebar"><Briefcase />Referenzen</RouterLink>
      <RouterLink to="/karriere" class="points-link" @click="closeSidebar"><BriefcaseBusiness />Karriere</RouterLink>
      <RouterLink to="/kontakt" class="points-link" @click="closeSidebar"><Contact />Kontakt & Angebot</RouterLink>
    </nav>

    <div class="sidebar-contact">
      <span>Direkt erreichbar</span>
      <a href="tel:+49123456789">+49 123 456789</a>
      <small>Mo–Fr, 07:00–17:00 Uhr</small>
    </div>
  </aside>
</template>
